import React from "react";
import PropTypes from "prop-types";
import { buildQAHook } from "shared/utils";
import { elementClicked } from "shared/components/Cohesion";
import styles from "./styles.css";

const handleTagularEvent = (event) => {
  const text = event.currentTarget.getAttribute("data-title");
  const url = event.currentTarget.getAttribute("data-url");

  elementClicked({
    webElement: {
      location: "Nav",
      elementType: "Link",
      position: "Main Sub Menu",
      text,
    },
    outboundUrl: url,
  });
};

const Item = ({ url, title }) => (
  <div className={styles.container}>
    <a
      href={url}
      className={styles.link}
      data-qa={buildQAHook(title, "nav", "link")}
      data-title={title}
      data-url={url}
      onClick={handleTagularEvent}
    >
      {title}
    </a>
  </div>
);

Item.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string.isRequired,
};

Item.defaultProps = {
  url: null,
};

export default Item;
